'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module4Res2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4Res2, _Component);

  function Module4Res2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4Res2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4Res2.__proto__ || (0, _getPrototypeOf2.default)(Module4Res2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Shopping with children'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module4Res2, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      var img1 = require('./Assets/img1.jpeg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'p',
                  null,
                  'Going shopping? Here are some tips for shopping with a young child:'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  '1. Before leaving home, tell your child that you are going shopping. Tell them what you want them to do when you are out.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For example, \'you need to stay close to me and ask before you touch\''
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  '2. Make a clear shopping list and explain to your child that you would like to stick to this list. They can help you to decide which foods to add to the list'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For example, whether they would like bananas or strawberries on their breakfast that week.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'However, they can\'t place items that are not on your shopping list in your shopping trolley when at the supermarket.'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8, sm: 8, xs: 8 },
                _react2.default.createElement(
                  'h4',
                  null,
                  '3. Involve your child in the shopping to keep them busy. Say things like:'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\'We are now looking for cheese, can you see some?\''
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\'We need some breakfast cereal; can you please pick that box up and put it in the trolley?\''
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\'See if you can find daddy\'s favourite fruit\''
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\'Let\'s look for all the things that are coloured red\''
                    )
                  )
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  '4. Pay attention to your child\'s behaviour'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For example, praise them and tell them what a big help they are.'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  '5. Decide what you will do if your child misbehaves or breaks the rules'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If they misbehave, explain to them what they are doing wrong and remind them of the rules.'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  '6. If they have behaved, after going through the checkout, praise them'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, sm: 4, xs: 4 },
                _react2.default.createElement(ReactBootstrap.Image, { src: img1, responsive: true })
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module4Res2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4Res2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/4/Res2.js
// module id = 1256
// module chunks = 0